<div class="admin-container">
  <div class="page-render">
    <div class="navbar">
      <img alt="logo" src="https://img.icons8.com/bubbles/50/000000/apple-clock.png"/>
      <div>
        <button mat-button
                *ngFor="let menu of menus"
                color="accent"
                [routerLink]="menu.path">
          {{menu.title}}
        </button>
        <button mat-icon-button color="accent" (click)="sync()"><mat-icon>sync</mat-icon></button>
        <button mat-flat-button color="accent" [routerLink]="['/presentation']">
          Apresentar
        </button>
      </div>
    </div>
    <div class="routing">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
